import { mapRange } from '@epihub/core/src/fn/range';
import { Dimension } from './Dimension';

export class Screen {
  readonly width: Dimension;
  readonly height: Dimension;

  get innerWidth() {
    return this.width;
  }

  get innerHeight() {
    return this.height;
  }

  constructor(widthPx: number, heightPx: number) {
    this.width = new Dimension(widthPx);
    this.height = new Dimension(heightPx);
  }

  fit(aspectRatio: number, mult: number = 1) {
    const desiredHeight = this.height.px;
    const desiredWidth = this.width.px;

    let height, width;

    if (desiredWidth / desiredHeight > aspectRatio) {
      // Screen is wider relative to its height than the image
      height = desiredHeight;
      width = desiredHeight * aspectRatio;
    } else {
      // Screen is taller relative to its width than the image
      width = desiredWidth;
      height = desiredWidth / aspectRatio;
    }

    return {
      width: width * mult,
      height: height * mult,
    };
  }

  readonly widthRange = (min: number, max: number) => {
    return mapRange(this.width.px, 320, 1024, min, max);
  };

  readonly heightRange = (min: number, max: number) => {
    return mapRange(this.height.px, 320, 1024, min, max);
  };
}
